/* Greenleaf — the shelf page's small helpers. 11 Oct 2026.
 *
 * (BACK TO TOP moved to assets/gl-top.js on 11 Oct 2026, so every long page has it.)
 *
 * CLOSE MATCHES on a search with no results, and NEAREST MATCHES when filters
 *    leave nothing. Both fill a hidden block (<div data-near="search|filters"
 *    data-sid="<section id>">) with up to six IN-STOCK cards read from the store's
 *    own pages through the Section Rendering API (?section_id=), the way
 *    gl-search-rank.js reads the results pages. If nothing is found, or anything
 *    fails, the block stays hidden and the page is as it was.
 *
 *    Search: the typed words are tried one by one (longest first), then the words
 *    run together (for "dia mond"), then the first five and four letters of each
 *    long word (for "diamnd"). Filters: the same shelf without the LAST filter in
 *    the address, which is the one the shopper added last.
 */
(function () {
  'use strict';

  /* ---- spelling help (17 Oct 2026, search polish) ----
   * Shopify's search forgives very little ("emrald" finds nothing). A word that is not one of the words this shop
   * sells by, but is one or two letters away from one, is swapped for it: emrald becomes emerald, diamnd diamond,
   * saphire sapphire. Only used when a search found nothing: the corrected words go first in the close matches and
   * "Did you mean ...?" offers the corrected search as a link. Words of three letters or fewer, and any word that IS
   * a known word, are left alone. The list is the store's own stones, metals, kinds of piece and motifs; add a word
   * here when a new kind of piece arrives. tests/test_search_typos.py runs this against sample typos.
   */
  var VOCAB = ('diamond diamonds emerald emeralds sapphire sapphires ruby rubies tanzanite pearl pearls aquamarine amethyst morganite ' +
    'tsavorite alexandrite turquoise opal opals onyx peridot topaz zircon quartz larimar amazonite tourmaline paraiba lapis lazuli garnet ' +
    'ring rings band bands necklace necklaces pendant pendants earring earrings stud studs hoop hoops dangle drop bracelet bracelets ' +
    'tennis chain chains signet cocktail eternity stackable solitaire engagement wedding anniversary halo gold platinum silver white yellow ' +
    'rose hawaiian honu plumeria turtle charm heart pave bezel oval round cushion pear marquise princess radiant asscher baguette trillion ' +
    'cabochon mens womens gift gifts custom repair repairs sizing').split(' ');
  var KNOWN = {};
  VOCAB.forEach(function (w) { KNOWN[w] = true; });

  function dist(a, b) {            // Damerau-Levenshtein: one swap of neighbours counts as one step
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) { d[i] = [i]; }
    for (j = 1; j <= b.length; j++) { d[0][j] = j; }
    for (i = 1; i <= a.length; i++) {
      for (j = 1; j <= b.length; j++) {
        var c = a[i - 1] === b[j - 1] ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
      }
    }
    return d[a.length][b.length];
  }
  function fixWord(w) {
    if (w.length < 4 || KNOWN[w] || /[^a-z]/.test(w)) return w;
    var max = w.length >= 7 ? 2 : 1, best = null, bd = 99, tie = false;
    for (var i = 0; i < VOCAB.length; i++) {
      if (Math.abs(VOCAB[i].length - w.length) > max) continue;
      var x = dist(w, VOCAB[i]);
      if (x < bd) { bd = x; best = VOCAB[i]; tie = false; } else if (x === bd && VOCAB[i] !== best) { tie = true; }
    }
    return (best && bd <= max && !tie) ? best : w;
  }
  function fix(q) {
    return String(q || '').toLowerCase().split(/\s+/).filter(Boolean).map(fixWord).join(' ');
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { fix: fix }; return; }

  /* ---- near matches ---- */
  var box = document.querySelector('[data-near]');
  if (!box || !('fetch' in window) || !('DOMParser' in window)) return;
  var grid = box.querySelector('ul.grid');
  var sid = box.getAttribute('data-sid');
  var mode = box.getAttribute('data-near');
  var params = new URLSearchParams(window.location.search);
  var seen = {};
  var got = [];
  var parser = new DOMParser();

  function take(html, term) {
    var doc = parser.parseFromString(html, 'text/html');
    var cards = doc.querySelectorAll('ul.grid:not(.nf__grid) > li.card');
    for (var i = 0; i < cards.length && got.length < 6; i++) {
      var li = cards[i];
      if (li.hasAttribute('data-sold')) continue;
      /* Shopify's search is loose and will hand back something for any word; keep a card only if its own
         words contain what was tried, so gibberish finds nothing instead of something unrelated */
      if (term && (li.getAttribute('data-w') || '').indexOf(term) < 0) continue;
      var a = li.querySelector('a');
      var href = a && a.getAttribute('href');
      if (!href || seen[href]) continue;
      seen[href] = true;
      got.push(li);
    }
  }
  function get(url) {
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 5000);
    return fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { clearTimeout(timer); return r.ok ? r.text() : ''; })
      .catch(function () { clearTimeout(timer); return ''; });
  }
  function show() {
    if (!got.length) return;
    got.forEach(function (li) {
      var n = document.importNode(li, true);
      n.removeAttribute('data-w');
      grid.appendChild(n);
    });
    box.hidden = false;
    /* the row of popular pieces further down does not repeat what is shown here */
    var all = document.querySelectorAll('ul.nf__grid');
    for (var g = 0; g < all.length; g++) {
      if (all[g] === grid) continue;
      var cs = all[g].querySelectorAll('li.card');
      for (var c = 0; c < cs.length; c++) {
        var ca = cs[c].querySelector('a');
        var hr = ca && ca.getAttribute('href');
        if (hr && seen[hr]) cs[c].remove();
      }
    }
  }
  function run(urls, terms) {
    var i = 0;
    (function next() {
      if (got.length >= 6 || i >= urls.length) { show(); return; }
      var k = i++;
      get(urls[k]).then(function (html) { if (html) take(html, terms ? terms[k] : ''); next(); });
    })();
  }

  if (mode === 'search') {
    var q = (params.get('q') || '').toLowerCase();
    var ws = (q.match(/[a-z0-9]+/g) || []).filter(function (w) { return w.length > 1; });
    if (!ws.length) return;
    // Mistyped words are corrected first (see "spelling help" above); the line offers the corrected search.
    var fixed = fix(ws.join(' '));
    if (fixed !== ws.join(' ')) {
      // The line is made here, only when there is a correction to offer (18 Oct 2026: the page used to carry
      // a hidden empty one that showed as "Did you mean this ?" on searches with nothing to correct).
      var head = document.querySelector('.dead--search .dead__h');
      if (head && !document.querySelector('[data-dym]')) {
        var dym = document.createElement('p');
        dym.className = 'nf__note dead__dym';
        dym.setAttribute('data-dym', '');
        dym.appendChild(document.createTextNode('Did you mean '));
        var link = document.createElement('a');
        link.href = '/search?q=' + encodeURIComponent(fixed);
        link.textContent = fixed;
        dym.appendChild(link);
        dym.appendChild(document.createTextNode('?'));
        head.insertAdjacentElement('afterend', dym);
      }
      ws = fixed.split(' ').concat(ws);
    }
    var terms = [];
    function add(t) { if (t.length > 2 && terms.indexOf(t) < 0) terms.push(t); }
    ws.slice().sort(function (a, b) { return b.length - a.length; }).forEach(add);
    for (var k = 0; k + 1 < ws.length; k++) add(ws[k] + ws[k + 1]);
    ws.forEach(function (w) { if (w.length >= 7) add(w.slice(0, 5)); });
    ws.forEach(function (w) { if (w.length >= 6) add(w.slice(0, 4)); });
    var tried = terms.slice(0, 8);
    run(tried.map(function (t) {
      return '/search?q=' + encodeURIComponent(t) + '&type=product&section_id=' + encodeURIComponent(sid);
    }), tried);
  } else if (mode === 'filters') {
    var pairs = window.location.search.replace(/^\?/, '').split('&').filter(function (p) {
      return /^filter\./.test(p);
    });
    if (!pairs.length) return;
    var path = window.location.pathname;
    var urls = [];
    /* drop the last filter in the address; if that still shows nothing, drop the last two */
    for (var d = 1; d <= Math.min(2, pairs.length); d++) {
      var rest = pairs.slice(0, pairs.length - d);
      urls.push(path + '?' + rest.concat(['section_id=' + encodeURIComponent(sid)]).join('&'));
    }
    run(urls);
    /* THE NEAREST REAL PRICE (2 Nov 2026): when the price is why nothing matched, say where prices start (or end) here,
       from the same collection and its other choices, sorted by price. */
    var closest = document.querySelector('[data-closest]');
    if (closest) {
      var up = closest.getAttribute('data-closest') === 'low';
      var keep = pairs.filter(function (p) { return !/^filter\.v\.price/.test(p); });
      var cu = path + '?' + keep.concat(['sort_by=' + (up ? 'price-ascending' : 'price-descending'), 'section_id=' + encodeURIComponent(closest.getAttribute('data-sid'))]).join('&');
      get(cu).then(function (html) {
        if (!html) return;
        var d = parser.parseFromString(html, 'text/html');
        var cs = d.querySelectorAll('ul.grid:not(.nf__grid) > li.card .card__price');
        for (var i = 0; i < cs.length; i++) {
          var m = (cs[i].textContent || '').match(/\$[\d,]+/);
          if (m) { closest.textContent = up ? 'The closest start at ' + m[0] + '.' : 'The most here is ' + m[0] + '.'; return; }
        }
      });
    }
  }
})();
